<template>
    <svg
        width="288"
        height="27"
        viewBox="0 0 288 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
            y="3"
            width="275"
            height="5"
            rx="2.5"
            fill="#E8EEF1" />
        <rect
            y="2"
            width="112"
            height="7"
            rx="3.5"
            fill="#7DD012" />
        <circle
            cx="56.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="110.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="83.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="137.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="164.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="191.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="245.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="218.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="272.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="29.5"
            cy="5.5"
            r="1.5"
            fill="white" />
        <circle
            cx="110.5"
            cy="5.5"
            r="4"
            fill="white"
            stroke="#7DD012"
            stroke-width="3" />
        <path
            d="M105.206 17.312V22.892H106.766V23.9H105.206V26H104.078V23.9H99.698L99.686 23.876L104.162 17.312H105.206ZM102.998 20.684L101.51 22.868L101.522 22.892H104.078V20.84C104.078 20.36 104.086 19.768 104.102 19.064L104.078 19.052C103.854 19.42 103.494 19.964 102.998 20.684ZM112.258 25.076C111.738 25.78 111.026 26.132 110.122 26.132C109.218 26.132 108.506 25.78 107.986 25.076C107.434 24.324 107.158 23.184 107.158 21.656C107.158 20.128 107.434 18.988 107.986 18.236C108.506 17.532 109.218 17.18 110.122 17.18C111.026 17.18 111.738 17.532 112.258 18.236C112.81 18.988 113.086 20.128 113.086 21.656C113.086 23.184 112.81 24.324 112.258 25.076ZM108.922 24.488C109.234 24.88 109.634 25.076 110.122 25.076C110.61 25.076 111.01 24.88 111.322 24.488C111.738 23.952 111.946 23.008 111.946 21.656C111.946 20.304 111.738 19.36 111.322 18.824C111.01 18.432 110.61 18.236 110.122 18.236C109.634 18.236 109.234 18.432 108.922 18.824C108.506 19.36 108.298 20.304 108.298 21.656C108.298 23.008 108.506 23.952 108.922 24.488ZM118.956 25.076C118.436 25.78 117.724 26.132 116.82 26.132C115.916 26.132 115.204 25.78 114.684 25.076C114.132 24.324 113.856 23.184 113.856 21.656C113.856 20.128 114.132 18.988 114.684 18.236C115.204 17.532 115.916 17.18 116.82 17.18C117.724 17.18 118.436 17.532 118.956 18.236C119.508 18.988 119.784 20.128 119.784 21.656C119.784 23.184 119.508 24.324 118.956 25.076ZM115.62 24.488C115.932 24.88 116.332 25.076 116.82 25.076C117.308 25.076 117.708 24.88 118.02 24.488C118.436 23.952 118.644 23.008 118.644 21.656C118.644 20.304 118.436 19.36 118.02 18.824C117.708 18.432 117.308 18.236 116.82 18.236C116.332 18.236 115.932 18.432 115.62 18.824C115.204 19.36 114.996 20.304 114.996 21.656C114.996 23.008 115.204 23.952 115.62 24.488Z"
            fill="#003545" />
        <path
            d="M264.316 26V18.716L262.324 19.484V18.392L265.456 17.18V26H264.316ZM272.63 25.076C272.11 25.78 271.398 26.132 270.494 26.132C269.59 26.132 268.878 25.78 268.358 25.076C267.806 24.324 267.53 23.184 267.53 21.656C267.53 20.128 267.806 18.988 268.358 18.236C268.878 17.532 269.59 17.18 270.494 17.18C271.398 17.18 272.11 17.532 272.63 18.236C273.182 18.988 273.458 20.128 273.458 21.656C273.458 23.184 273.182 24.324 272.63 25.076ZM269.294 24.488C269.606 24.88 270.006 25.076 270.494 25.076C270.982 25.076 271.382 24.88 271.694 24.488C272.11 23.952 272.318 23.008 272.318 21.656C272.318 20.304 272.11 19.36 271.694 18.824C271.382 18.432 270.982 18.236 270.494 18.236C270.006 18.236 269.606 18.432 269.294 18.824C268.878 19.36 268.67 20.304 268.67 21.656C268.67 23.008 268.878 23.952 269.294 24.488ZM279.328 25.076C278.808 25.78 278.096 26.132 277.192 26.132C276.288 26.132 275.576 25.78 275.056 25.076C274.504 24.324 274.228 23.184 274.228 21.656C274.228 20.128 274.504 18.988 275.056 18.236C275.576 17.532 276.288 17.18 277.192 17.18C278.096 17.18 278.808 17.532 279.328 18.236C279.88 18.988 280.156 20.128 280.156 21.656C280.156 23.184 279.88 24.324 279.328 25.076ZM275.992 24.488C276.304 24.88 276.704 25.076 277.192 25.076C277.68 25.076 278.08 24.88 278.392 24.488C278.808 23.952 279.016 23.008 279.016 21.656C279.016 20.304 278.808 19.36 278.392 18.824C278.08 18.432 277.68 18.236 277.192 18.236C276.704 18.236 276.304 18.432 275.992 18.824C275.576 19.36 275.368 20.304 275.368 21.656C275.368 23.008 275.576 23.952 275.992 24.488ZM286.026 25.076C285.506 25.78 284.794 26.132 283.89 26.132C282.986 26.132 282.274 25.78 281.754 25.076C281.202 24.324 280.926 23.184 280.926 21.656C280.926 20.128 281.202 18.988 281.754 18.236C282.274 17.532 282.986 17.18 283.89 17.18C284.794 17.18 285.506 17.532 286.026 18.236C286.578 18.988 286.854 20.128 286.854 21.656C286.854 23.184 286.578 24.324 286.026 25.076ZM282.69 24.488C283.002 24.88 283.402 25.076 283.89 25.076C284.378 25.076 284.778 24.88 285.09 24.488C285.506 23.952 285.714 23.008 285.714 21.656C285.714 20.304 285.506 19.36 285.09 18.824C284.778 18.432 284.378 18.236 283.89 18.236C283.402 18.236 283.002 18.432 282.69 18.824C282.274 19.36 282.066 20.304 282.066 21.656C282.066 23.008 282.274 23.952 282.69 24.488Z"
            fill="#A6A4A6" />
    </svg>
</template>

<script>
    export default {}
</script>
